import { Tag } from '@eye-able/ui';
import { useBadgeVisibility } from '@layout/Sidebar/MenuList/useBadgeVisibility';
import type { MenuItem } from '@layout/Sidebar/MenuList/types';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

type NavItemLabelProps = {
  item: MenuItem;
};

function NavItemLabel({ item }: NavItemLabelProps) {
  const { t } = useInlineTranslation();
  const Icon = item.handle.icon;
  const badge = item.handle.badge;
  const title = item.handle.i18nNameKey
    ? t(item.handle.i18nNameKey)
    : (item.handle.name ?? '');

  const showBadge = useBadgeVisibility(badge);

  return (
    <div className='eye:flex eye:items-center eye:text-left'>
      {Icon ? (
        <div className='eye:mr-4xs' aria-hidden={true}>
          <Icon className='eye:w-24 eye:h-24' strokeWidth={1.6} />
        </div>
      ) : null}
      {title}
      {showBadge ? (
        <Tag className='eye:ml-4xs eye:capitalize eye:justify-center'>
          {badge?.text ? t(badge.text) : null}
        </Tag>
      ) : null}
    </div>
  );
}

export default NavItemLabel;
